import { render } from "./money_l_items.vue?vue&type=template&id=5b1855fe&scoped=true"
import script from "./money_l_items.vue?vue&type=script&lang=js"
export * from "./money_l_items.vue?vue&type=script&lang=js"

import "./money_l_items.vue?vue&type=style&index=0&id=5b1855fe&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1855fe"]])

export default __exports__